import React, { ReactNode, useState } from 'react'
import { SWPMasterPayload } from '../../types/mf-execution.types'
import {
  OTPVerificationState,
  OTPVerificationHandlers,
  OTPVerificationFailedCase as OTPFailedCase
} from '../../types/otp.types'
import { SWPContext } from '../contexts/SWPContext'

interface SWPProviderProps {
  children: ReactNode
}

const SWPProvider: React.FC<SWPProviderProps> = ({ children }) => {
  const [isSWPOTPVerified, setIsSWPOTPVerified] = useState(false)
  const [swpMasterPayload, setSWPMasterPayload] = useState<SWPMasterPayload>({
    swp: null
  })

  // OTP Verification State
  const [isOTPVerificationLoading, setIsOTPVerificationLoading] = useState(false)
  const [isOTPVerificationLimitExceeded, setIsOTPVerificationLimitExceeded] = useState(false)
  const [OTPVerificationFailedCase, setOTPVerificationFailedCase] = useState<OTPFailedCase | null>(null)

  const handleSWPMasterPayload = (payload: SWPMasterPayload) => {
    setSWPMasterPayload(payload)
  }

  const handleSWPOTPVerification = async (otp: string) => {
    console.log('SWP OTP verification:', otp)
    setIsOTPVerificationLoading(true)

    try {
      // Simulate API call
      await new Promise((resolve) => setTimeout(resolve, 1000))

      // For demo purposes, assume OTP is valid if it's 6 digits
      if (otp.length === 6 && /^\d{6}$/.test(otp)) {
        setIsSWPOTPVerified(true)
        setOTPVerificationFailedCase(null)
        console.log('SWP OTP verified successfully')
      } else {
        setOTPVerificationFailedCase(OTPFailedCase.INVALID_OTP)
        console.log('SWP OTP verification failed')
      }
    } catch (error) {
      setOTPVerificationFailedCase(OTPFailedCase.OTP_VERIFICATION_FAILED)
      console.error('SWP OTP verification error:', error)
    } finally {
      setIsOTPVerificationLoading(false)
    }
  }

  const handleSWPResendOTP = () => {
    console.log('SWP OTP resend requested')
    setIsOTPVerificationLimitExceeded(false)
    setOTPVerificationFailedCase(null)
    // Simulate API call to resend OTP
  }

  const otpVerificationState: OTPVerificationState = {
    isOTPVerified: isSWPOTPVerified,
    isOTPVerificationLoading,
    isOTPVerificationLimitExceeded,
    OTPVerificationFailedCase
  }

  const otpVerificationHandlers: OTPVerificationHandlers = {
    handleOTPVerification: handleSWPOTPVerification,
    handleResendOTP: handleSWPResendOTP
  }

  return (
    <SWPContext.Provider
      value={{
        swpMasterPayload,
        handleSWPMasterPayload,
        isSWPOTPVerified,
        handleSWPOTPVerification,
        otpVerificationState,
        otpVerificationHandlers
      }}
    >
      {children}
    </SWPContext.Provider>
  )
}

export default SWPProvider
